import { render, staticRenderFns } from "./ShareModalFooter.vue?vue&type=template&id=2a2b5fd6&scoped=true&"
import script from "./ShareModalFooter.vue?vue&type=script&lang=js&"
export * from "./ShareModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ShareModalFooter.vue?vue&type=style&index=0&id=2a2b5fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b5fd6",
  null
  
)

export default component.exports